// removed by extract-text-webpack-plugin
module.exports = {"root":"LatestBulletinsItem-module-root-vmrv-","title":"LatestBulletinsItem-module-title-1mLwL","description":"LatestBulletinsItem-module-description-kUmAh","link":"LatestBulletinsItem-module-link-1qvKa","btn-text":"LatestBulletinsItem-module-btn-text-1-iKE","btnText":"LatestBulletinsItem-module-btn-text-1-iKE","btn-icon":"LatestBulletinsItem-module-btn-icon-lRk2W","btnIcon":"LatestBulletinsItem-module-btn-icon-lRk2W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LatestBulletinsItem/LatestBulletinsItem.module.scss
// module id = 1113
// module chunks = 0